import { scaleDiverging } from 'd3-scale';
import ContinuousSchemeWrapper from './ContinuousSchemeWrapper';
export default class DivergingSchemeWrapper extends ContinuousSchemeWrapper {
  getColors(numColors = 3, extent = [0, 1]) {
    return super.getColors(numColors, extent);
  }

  createScaleLinear() {
    return scaleDiverging(this.interpolator);
  }

}